import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-triangle-left",
  templateUrl: "./med-icon-triangle-left.component.html",
})
export class MedIconTriangleLeftComponent extends SvgMixinComponent {}
